"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateLumpSumPremium = exports.calculateFaceFactorPremiumFactor = void 0;
const common_1 = require("../../../../../common");
const common_2 = require("../../../../common");
const get_lump_sum_payment_adjustment_1 = require("./get-lump-sum-payment-adjustment");
const get_lump_sum_payment_method_factor_1 = require("./get-lump-sum-payment-method-factor");
function calculateFaceFactorPremiumFactor(options, faceFactor, premiumFactor) {
    const paymentMethodFactor = get_lump_sum_payment_method_factor_1.getLumpSumPaymentMethodFactor(options);
    const paymentPeriodFactor = common_1.getPaymentPeriodFactor(options.paymentPeriod);
    return faceFactor * premiumFactor * paymentMethodFactor * paymentPeriodFactor;
}
exports.calculateFaceFactorPremiumFactor = calculateFaceFactorPremiumFactor;
function calculateLumpSumPremium(options, rate, faceFactor, premiumFactor) {
    if (!options.lumpSumAmount) {
        throw new Error('Calculating a lump sum premium without a lump sum is not supported');
    }
    const faceFactorPremiumFactor = calculateFaceFactorPremiumFactor(options, faceFactor, premiumFactor);
    const downPaymentFactor = rate.downPaymentFactor || 1;
    const lumpSumAmount = options.lumpSumAmount;
    const paymentAdjustment = get_lump_sum_payment_adjustment_1.getLumpSumPaymentAdjustment(options);
    const faceAmount = faceFactorPremiumFactor * options.amount;
    const lumpSumFaceAmount = faceFactorPremiumFactor * lumpSumAmount * downPaymentFactor + paymentAdjustment;
    const denominator = 1 - faceFactorPremiumFactor * downPaymentFactor;
    const premium = (faceAmount - lumpSumFaceAmount) / denominator;
    return common_2.roundPayment(premium);
}
exports.calculateLumpSumPremium = calculateLumpSumPremium;
//# sourceMappingURL=lump-sum-premium-calculator.js.map